export default __webpack_public_path__ + "static/media/ORYX_MagnifyingGlassIcon.038921ae.svg";